import classnames from 'classnames';

const className = classnames(
  'text-alert-text-color',
  'text-center',
  'text-4xl'
);

interface Props {
  children: string;
}

const Alert = ({ children }: Props) => (
  <h1 className={className}>{children}</h1>
);

export default Alert;
